if (!window.mafeEditorialPrivacyReady) {
  window.mafeEditorialPrivacyReady = true;
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-mf-cookie-preferences]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    try {await window.privacyBanner.showPreferences();}
    catch {window.location.assign(link.href);}
  });
}
